import { useContext } from "react";
import { AuthContext } from "../components/auth/AuthProvider";
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const { user, googleUser, loading, precentCompletion } =
    useContext(AuthContext);

  if (loading) {
    return null;
  }

  if (user === null && googleUser === null) {
    return <Navigate to="/login" replace />;
  }

  if (precentCompletion.length > 0 && precentCompletion < 25) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
